

















































import { Component, Prop, Vue } from 'vue-property-decorator'
import SongRequest from '@/types/SongRequest'
import { namespace } from 'vuex-class'
import APIClient from '@/API/APIClient'
import Vote from '@/types/Vote'
import { MutationMethod } from 'vuex'

const userModule = namespace('user')
const partyRoomModule = namespace('partyRoom')

@Component
export default class SongRequestDisplayer extends Vue {
  @Prop() request!: SongRequest
  @Prop() index!: number
  @userModule.Getter('songsVotedForArray') songsVotedForArray!: Array<string>
  @userModule.Getter('songsVotedFor') songsVotedFor!: { [requestID: string]: Vote }
  @userModule.Getter('userID') userID!: string
  @userModule.Mutation('addSongVotedFor') addSongVotedFor!: MutationMethod
  @userModule.Mutation('removeSongVotedFor') removeSongVotedFor!: MutationMethod
  @partyRoomModule.Getter('partyID') partyID!: string

  private lastVoteTime?: number

  get hasVotedForSong (): boolean {
    return this.request.requestId ? this.songsVotedForArray.includes(this.request.requestId) : false
  }

  get hasAddedSong (): boolean {
    return this.request.addedBy === this.userID
  }

  private checkIfUserIsAllowed () {
    if (!this.lastVoteTime) return true
    return this.lastVoteTime < Date.now() - 500
  }

  private async voteForSong () {
    console.log('yo')
    if (!this.request.requestId || !this.checkIfUserIsAllowed()) return
    this.lastVoteTime = Date.now()
    console.log('hello')
    try {
      if (!this.hasVotedForSong) {
        const vote: Vote = {
          requestID: this.request.requestId,
          userID: this.userID
        }
        vote.voteID = await APIClient.User.voteForSong(this.partyID, vote)
        this.addSongVotedFor(vote)
      } else {
        APIClient.User.removeVoteForSong(this.partyID, this.songsVotedFor[this.request.requestId])
        this.removeSongVotedFor(this.songsVotedFor[this.request.requestId])
      }
    } catch (e) {
      console.log(e)
    }
  }

  private async deleteSong () {
    if (!this.request.requestId) return
    try {
      await APIClient.PartyRoom.removeSongRequest(this.partyID, this.request)
    } catch (e) {
      console.log(e)
    }
  }
}
